import { Pencil } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const EditIcon = createLucideIcon(Pencil);
